// lazy load maplibre js

function loadMapLibre() {
	if(window.maplibregl) return;
	const script = document.createElement('script');
	script.src = '/assets/js/vendor/maplibre-gl.js';
	script.async = true;
	document.body.appendChild(script);
}

/*
window.addEventListener('load', () => {
	const maps = document.querySelectorAll('.map');
	if(maps.length === 0 && !document.body.hasAttribute('data-use-maps')) return;
	if('requestIdleCallback' in window) {
		requestIdleCallback(loadMapLibre, { timeout: 2000 });
	}
	else {
		setTimeout(loadMapLibre, 0);
	}
});
*/

window.addEventListener('load', () => {
	const maps = document.querySelectorAll('.map');
	if(maps.length === 0 && !document.body.hasAttribute('data-use-maps')) return;
	loadMapLibre();
});
